module.exports = __webpack_public_path__ + "static/media/Algarve.f317681d.svg";